// extracted by mini-css-extract-plugin
export default {"centerBlock":"Map_centerBlock__OEeU3"};